import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Container, Typography, Button, Paper, Grid } from "@mui/material";

export const Submitted = () => {
  const navigate = useNavigate();
  return (
    <Container
      maxWidth="lg"
      sx={{
        mt: 4,
        mb: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper variant="outlined" sx={{ my: { xs: 3 }, p: { xs: 2, md: 3 } }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography sx={{ mt: 2, mb: 1, textAlign: "center" }}>
              The answer submitted successfully. You&apos;ll recieve an email
              with evaluation result in the next few days! Please check your
              spam or junk folder just in case it doesn&apos;t appear in your
              inbox!
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                pt: 2,
                justifyContent: "center",
              }}
            >
              <Box sx={{ flex: "1 1 auto" }} />
              <Button onClick={() => navigate(-1, { replace: true })}>
                Back
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};
